import {BusPartnerSource, BusPartnerStatus, PartnersState} from './types';

export const initPartnerObject = {
  id: null,
  name: '',
  mobilityPartnerId: null,
  countryId: '',
  depots: [],
  status: BusPartnerStatus.Active,
  source: BusPartnerSource.Cpc
};
export const initPartnerDepotObject = {
  city: '',
  postCode: '',
  street: ''
};

export const partnersInitialState: PartnersState = {
  list: null,
  partner: null,
  partnersLoading: false
};
